import React from 'react'
import './Navbar.css'
import data from './data'
import logo from '../../assets/slogo.png'
import { IoIosColorPalette } from  'react-icons/io'
import { useState, useEffect, useRef} from 'react'
import '../Navbar/theme'
import Theme from '../../theme/Theme'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';






const Navbar = () => {

  const { ref, inView } = useInView({
    threshold: 0.3, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const topVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 2 } }
  };

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView]);







  const [themeColor, setThemeColor] = useState('--color-primary');

  function handleThemeColorChange(color) {
    setThemeColor(color);
    document.documentElement.style.setProperty('--color-primary', color);
  }
  
  



  const [showModal, setShowModal] = useState(false);

  function handleButtonClick() {
    setShowModal(true);
  }
  
  function handleCloseModal() {
    setShowModal(false);
  }
   

  let menuRef = useRef();

  useEffect(() => {
    let handler = (e)=> {
      if(menuRef.current.contains(e.target)){
        showModal(false);
        console.log(menuRef.current);
      }
    }
  })







  // this is for framer motion it only appears when the page is seen by user


 






  


  return (
    
    <nav ref={ref}>
      <div className="container nav__container">
        <motion.div 
        variants={topVariants} 
        initial="hidden"
        animate={animation}
        className='nav__logo'
        >

        <a href="index.html"   variants={topVariants} 
          initial="hidden"
          animate={animation}
        >
          <img src={logo} alt="logo"/>
        </a>
        </motion.div>

        <ul className='nav__menu'>
            {
              data.map(item => <motion.li 
                animate={{ opacity: 1, y:0 }}
                transition={{
                  duration:1,
                  ease:"easeInOut",
                  delay: 0.3 + item * 0.5, 
                }}initial={{ opacity:0, y:-25 }}
                
                
                
                
                key={item.id}><a href={item.link}>{item.title}</a></motion.li>)
            }
        </ul>
        <motion.div
        variants={topVariants} 
        initial="hidden"
        animate={animation}
        >
        <button  
        className='theme__icon' onClick={handleButtonClick}
        ><IoIosColorPalette/></button></motion.div>
        <Theme ref={menuRef} show={showModal}   onClose={handleCloseModal} onChange={handleThemeColorChange} /> 

      </div>
    </nav>
  )
}

export default Navbar